import React from 'react'
import './TableLoader.sass'

// @component
export default function () {

  return (
    <>
      <div className='table-loader'>
        <div />
        <div />
        <div />
        <div />
      </div>
    </>
  )
}